export enum FormType {
    Experience = "Experience",
    Feedback = "Feedback",
    Plan = "Plan",
    Reflection = "Reflection",
    Talent = "Talent",
    Worksheet = "Worksheet"
}
